import React from 'react';

const ExportConfirmation = ({ onConfirm, onCancel, itemName }) => (
    <div className="overlay-fade-in" style={{ position: 'fixed', inset: 0, background: 'rgba(26, 28, 29, 0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000, backdropFilter: 'blur(4px)' }} onClick={onCancel}>
        <div className="modal-fade-in" style={{ width: 400, background: '#fff', borderRadius: 12, padding: 32, textAlign: 'center', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }} onClick={e => e.stopPropagation()}>
            <div style={{ background: '#e3f2fd', color: '#1976d2', width: 56, height: 56, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
            </div>
            <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#1a1c1d' }}>Export Confirmation</h2>
            <p style={{ fontSize: 13, color: '#6d7175', margin: '0 0 24px' }}>
                Are you sure you want to download the <strong>{itemName}</strong> CSV file?
            </p>
            <div style={{ display: 'flex', gap: 12 }}>
                <button onClick={onCancel} style={{ flex: 1, padding: '10px', borderRadius: 8, border: '1px solid #d2d2d2', background: '#fff', color: '#1a1c1d', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
                    Cancel
                </button>
                <button onClick={onConfirm} style={{ flex: 1, padding: '10px', borderRadius: 8, border: 'none', background: '#1976d2', color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
                    Download CSV
                </button>
            </div>
        </div>
    </div>
);

export default ExportConfirmation;
